import { render, staticRenderFns } from "./TileBookshelf.vue?vue&type=template&id=f4fe5e0c&scoped=true&"
import script from "./TileBookshelf.vue?vue&type=script&lang=ts&"
export * from "./TileBookshelf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fe5e0c",
  null
  
)

export default component.exports